import React from "react";
import { useParams, Link } from "react-router-dom";
import "../styles/product.css";
import coaxiais from "../assets/images/products/cabos/coaxial/Cabo-Dados-Radiaflex.jpg";
import { sampleProducts } from "../data/productsfamily";
import eia from "../assets/images/products/acessorios/ACESSORIOS.jpg"

import antenas_microondas from "../assets/images/products/antenas_rfs/Antenas-Microondas.jpeg"

const WhitelabelProductPage = () => {
  const { category } = useParams();
  const products = sampleProducts[category] || [];

  const uniqueTypes = [...new Set(products.map((product) => product.type))];

  return (
    <div className="products-container">
      <h1 className="heading">{category.replace("_", " ").toUpperCase()}</h1>
      <div className="products-grid centered-grid">
        {uniqueTypes.length > 0 ? (
          uniqueTypes.map((type, index) => {
            const originalProduct = products.find((product) => product.type === type);

            if (!originalProduct) return null;

            // Criando uma cópia do produto com imagem personalizada se necessário
            const product = {
              ...originalProduct,
              image:
                originalProduct.type === "Coaxial"
                  ? coaxiais
                  : originalProduct.type === "Microondas"
                  ? antenas_microondas
                  : originalProduct.type == "Conectores"
                  ? eia
                  : originalProduct.image,
            };
            return (
              <div key={index} className="product-card enhanced-card">
                <h6 className="product-type">{type}</h6>
                <Link to={`/produtos/${category}/${type}`}>
                  <img
                    src={product.image}
                    alt={product.name}
                    className="product-image clickable"
                  />
                </Link>
              </div>
            );
          })
        ) : (
          <p className="no-products">Nenhum produto encontrado.</p>
        )}
      </div>
    </div>
  );
};

export default WhitelabelProductPage;
